import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { removeLanguageFromPath } from "./languageCore";

/**
 * Component that handles fallback redirects for invalid language routes.
 * If a user hits a language-prefixed route that doesn't exist as a client-side route
 * (e.g., /fr/some-unknown-page), this component will redirect them to the
 * non-language version (e.g., /some-unknown-page) using a full page navigation
 * so the server can handle routes that only exist server-side.
 */
const LanguageFallbackRedirect: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Remove the language prefix from the current path
    const pathWithoutLanguage = removeLanguageFromPath(location.pathname);

    // Preserve query string and hash
    const search = location.search || "";
    const hash = location.hash || "";

    // Redirect to the path without language prefix
    const redirectPath = `${pathWithoutLanguage}${search}${hash}`;

    // Use full page navigation so the server can handle routes
    // that only exist server-side (e.g., /help → external redirect)
    if (typeof window !== "undefined") {
      window.location.replace(redirectPath);
    }
  }, [location]);

  // Return null while redirecting
  return null;
};

export default LanguageFallbackRedirect;
